/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SmartAssistantStrService } from '../smart-assistant-str.service';

@Component({
    selector: 'app-smart-assistant-object-container',
    templateUrl: './object-container.component.html',
    styleUrls: ['./object-container.component.scss'],
})
export class SmartAssistantObjectContainerComponent {
    /**
     * 对象的图标
     */
    @Input() icon: string;
    /**
     * 对象的名称
     */
    @Input() name: string;
    /**
     * 操作按钮的名称
     */
    @Input() operateLabel: string;

    /**
     * 点击了返回按钮
     */
    @Output() onClick = new EventEmitter<void>();

    constructor(public str: SmartAssistantStrService) { }

    clickBtn(): void {
        this.onClick.emit();
    }
}
